import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

export const getSellerContact = async (inventoryId) => {
  const response = await apiService.apiCall(
    `${baseURL}api/v2/inventory/${Number(inventoryId)}/seller-contact`,
    "GET",
    {},
  );
  if (response?.errorCode !== 0) {
    throw new Error(response?.message || "Seller contact did not load");
  }
  return response?.result?.contact || null;
};
